import { jsx as t } from "react/jsx-runtime";
function e(r) {
  return /* @__PURE__ */ t(
    "svg",
    {
      width: "14",
      height: "14",
      viewBox: "0 0 14 14",
      fill: "none",
      stroke: "rgb(var(--text-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          d: "M3 9.66666C3 11.1394 4.19391 12.3333 5.66667 12.3333H8.33333C9.80609 12.3333 11 11.1394 11 9.66666C11 8.1939 9.80609 7 8.33333 7M11 4.33333C11 2.86057 9.80609 1.66666 8.33333 1.66666H5.66667C4.19391 1.66666 3 2.86057 3 4.33333M1 7H13",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
export {
  e as default
};
